import React from 'react'
import { Route, Routes } from 'react-router'

import SystemMasterListPage from '../app/master/pages/SystemMasterListPage'

import BusinessDetails from '../app/admin/business/pages/BusinessDetails'

import PrintSettingPage from '../app/admin/business/pages/PrintSettingPage'
import ManagerRoutes from './ManagerRoutes'




function AppRoutes() {
  return (
    <>
      <Routes>
          {/* Admin */}
          <Route path="/business/details" element={<BusinessDetails />}></Route>
          <Route path="/print/setting" element={<PrintSettingPage />}></Route>
          
          {/* System */}
          <Route path="/master/list" element={ <SystemMasterListPage /> } />
      </Routes>
      <ManagerRoutes/>
    </>
  )
}

export default AppRoutes